import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/696326ed7683ed0014e4c731/ecofiber_calculator/src/app/fabric-database/components/FabricDatabaseInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/696326ed7683ed0014e4c731/ecofiber_calculator/src/components/common/Header.tsx");
